import { createElementBlock as a, openBlock as t, normalizeClass as d, createElementVNode as m, renderSlot as u, createBlock as o, createCommentVNode as i, unref as r, Fragment as y, renderList as h, createVNode as w, toDisplayString as c } from "vue";
import { themeProp as b } from "../../composables/useTheme.js";
import { screenProp as k } from "../../utils/utilsScreen.js";
import { useTracking as v } from "../../composables/useTracking.js";
import S from "../link/link.vue.js";
import x from "../video-player/video-player.vue.js";
/* empty css          */
import j from "../../_virtual/_plugin-vue_export-helper.js";
import z from "../../utils/validators/video-player.js";
import T from "../../atoms/image-element/image-element.vue.js";
import B from "../../atoms/tag/tag.vue.js";
import C from "../../atoms/icon/icon.vue.js";
const P = {
  key: 0,
  class: "ds-display-flex ds-margin-bottom-12"
}, $ = {
  key: 1,
  class: "ds-display-flex ds-margin-bottom-24"
}, L = {
  key: 0,
  class: "ds-text ds-margin-top-12",
  "data-j-text": ""
}, g = "DsCard", N = /* @__PURE__ */ Object.assign({
  name: g
}, {
  __name: "card",
  props: {
    ...b,
    ...k,
    title: { type: String, default: "" },
    text: { type: String, default: "" },
    icon: { type: Object, default: null },
    subtitle: { type: String, default: "" },
    link: {
      type: Object,
      default: null,
      validator: (e) => ["title", "url", "openInNewWindow", "nuxt"].every((n) => n in e)
    },
    image: {
      type: Object,
      default: null,
      validator: (e) => ["small", "medium", "large"].every(
        (n) => n in e && ["src", "name"].every((l) => l in e[n])
      )
    },
    video: {
      type: Object,
      default: null,
      validator: (e) => z(e)
    },
    aspectRatio: { type: String, default: null },
    withTitleSizeLarge: { type: Boolean, default: !1 },
    withTitleSizeSmall: { type: Boolean, default: !1 },
    withShadow: { type: Boolean, default: !1 },
    withContentPadding: { type: Boolean, default: !1 },
    tags: { type: Array, default: () => [] },
    tagColor: { type: String, default: "green" },
    withSubtitleTopMargin: { type: Boolean, default: !0 }
  },
  setup(e) {
    const { trackingDataProvided: n } = v();
    return (l, O) => (t(), a("div", {
      class: d(`ds-card ds-card--${l.theme}`)
    }, [
      m("div", {
        class: d([{ "ds-shadow": e.withShadow }, "ds-card__media"]),
        "data-j-card-media": ""
      }, [
        u(l.$slots, "media", {}, () => [
          e.image ? (t(), o(r(T), {
            key: 0,
            "aspect-ratio": e.aspectRatio,
            image: e.image,
            screen: l.screen,
            "data-j-image": ""
          }, null, 8, ["aspect-ratio", "image", "screen"])) : e.video ? (t(), o(x, {
            key: 1,
            thumbnail: e.video.thumbnail,
            "aria-label-play": e.video.ariaLabelPlay,
            "aria-label-close": e.video.ariaLabelClose,
            "self-hosted": e.video.selfHosted,
            extension: e.video.extension,
            src: e.video.src,
            title: e.video.title,
            screen: l.screen,
            "data-j-video": ""
          }, null, 8, ["thumbnail", "aria-label-play", "aria-label-close", "self-hosted", "extension", "src", "title", "screen"])) : i("", !0)
        ], !0)
      ], 2),
      m("div", {
        class: d(["ds-card__content ds-display-flex ds-flex-direction-column", { "ds-padding-24 ds-md-padding-48": e.withContentPadding }])
      }, [
        e.tags && e.tags.length ? (t(), a("div", P, [
          (t(!0), a(y, null, h(e.tags, (s, f) => (t(), a("div", {
            key: `ds-card--tab-${s}`,
            class: d({ "ds-margin-left-8": f !== 0 })
          }, [
            w(r(B), {
              label: s,
              color: e.tagColor
            }, null, 8, ["label", "color"])
          ], 2))), 128))
        ])) : i("", !0),
        e.icon ? (t(), a("div", $, [
          e.icon ? (t(), o(r(C), {
            key: 0,
            name: e.icon.name,
            category: e.icon.category,
            class: "ds-color-green",
            "data-j-icon": ""
          }, null, 8, ["name", "category"])) : i("", !0)
        ])) : i("", !0),
        e.title ? (t(), a("h2", {
          key: 2,
          class: d({
            "ds-heading": e.withTitleSizeLarge && !e.withTitleSizeSmall,
            "ds-heading-small": !e.withTitleSizeLarge && !e.withTitleSizeSmall,
            "ds-heading-xsmall": !e.withTitleSizeLarge && e.withTitleSizeSmall
          }),
          "data-j-title": ""
        }, c(e.title), 3)) : i("", !0),
        e.subtitle ? (t(), a("p", {
          key: 3,
          class: d(["ds-card__content__subtitle ds-text", { "ds-margin-top-8": e.withSubtitleTopMargin }]),
          "data-j-subtitle": ""
        }, c(e.subtitle), 3)) : i("", !0),
        u(l.$slots, "text", {}, () => [
          e.text ? (t(), a("p", L, c(e.text), 1)) : i("", !0)
        ], !0),
        e.link ? (t(), o(S, {
          key: 4,
          content: e.link.title,
          "tracking-data": { "component-name": g, text: e.link.title, title: e.title, ...r(n) },
          url: e.link.url,
          "lazy-url-endpoint": e.link.lazyUrlEndpoint,
          "open-in-new-window": e.link.openInNewWindow,
          nuxt: e.link.nuxt,
          "icon-right": { category: "arrows", name: "chevron-right-small" },
          class: "ds-card__content__link ds-margin-top-24",
          "data-j-link": ""
        }, null, 8, ["content", "tracking-data", "url", "lazy-url-endpoint", "open-in-new-window", "nuxt"])) : i("", !0)
      ], 2)
    ], 2));
  }
}), G = /* @__PURE__ */ j(N, [["__scopeId", "data-v-c9b80683"]]);
export {
  G as default
};
